




import { Component, Mixins, Prop } from "vue-property-decorator";

@Component
export default class ConfirmView extends Mixins() {
  @Prop()
  title: string;

  @Prop()
  message: string;

  @Prop()
  actionButtonName: string;

  @Prop()
  cancelButtonName: string;

  @Prop()
  destination: string;

  async mounted() {
    await this.confirm();
  }

  async confirm(): Promise<void> {
    const resultIndex = await this.$commonDialogs.confirmation.confirmDangerCancel(
      this.title,
      this.splitByReturnCode(this.message),
      this.actionButtonName,
      this.cancelButtonName
    );
    if (resultIndex === 0) {
      this.$router.replace(JSON.parse(this.destination));
    } else {
      this.$closeWindow(true);
    }
  }

  private splitByReturnCode(text: string): string[] {
    if (!text) { return [""]; }
    return text.split(/\r\n|\n/);
  }
}
